import AccessibilityIcon from "@mui/icons-material/Accessibility";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AirlineSeatFlatIcon from "@mui/icons-material/AirlineSeatFlat";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import BedroomParentIcon from "@mui/icons-material/BedroomParent";
import BloodtypeIcon from "@mui/icons-material/Bloodtype";
import EmergencyIcon from "@mui/icons-material/Emergency";
import HealingIcon from "@mui/icons-material/Healing";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import HistoryIcon from "@mui/icons-material/History";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LogoutIcon from "@mui/icons-material/Logout";
import MasksIcon from "@mui/icons-material/Masks";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import MedicationIcon from "@mui/icons-material/Medication";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import SickIcon from "@mui/icons-material/Sick";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { useSelector } from "react-redux";

const useUserType = () => {
  const loginValues = useSelector((state) => state.values?.loginValues || []);
  const userType = loginValues[0]?.user?.user_type || null;
  return userType;
};

export default useUserType;

export const APP_LINK = {
  LOGIN: "/",
  REGISTER: "/register",
  FORGOTPASSWORD: "/forgotPassword",
  OTPREQUEST: "/otpScreen",
  PASSWORDRESET: "/passwordReset",
  DASHBOARD: "/dashboard",
  MYPROFILE: "/my-profile",
  ADDPATIENT: "/patient/add",
  EDITPATIENT: "/patient/edit/:id",
  VIEWPATIENT: "/patient/view/:id",
  LISTALLPATIENT: "/patient/list",
  ADDSTAFF: "/staff/add",
  EDITSTAFF: "/staff/edit/:id",
  VIEWSTAFF: "/staff/view/:id",
  LISTALLSTAFF: "/staff/list",
  ADDDOCTOR: "/doctor/add",
  EDITDOCTOR: "/doctor/edit/:id",
  VIEWDOCTOR: "/doctor/view/:id",
  LISTDOCTOR: "/doctor/list",
  HISTORY: "/history",
  ROLEPERMISSION: "/role-permission",
  ADDSECURITYGUARD: "/securityOfficer/add",
  EDITSECURITYGUARD: "/securityOfficer/edit/:id",
  LISTECURITYGUARD: "/securityOfficer/list",
  VIEWSECURITYGUARD: "/securityOfficer/view/:id",
  FLOORLIST: "/floor/list",
  WARDLIST: "/ward/list",
  BLOCKLIST: "/block/list",
  HOSPITAREQUIREDNMENT: "/requirement",
  REQUIREMENTS: "/requirements",
  LOGOUT: "/logout",
  CHANGEPASSWORD: "/changePassword",
  PATIENTTRANSFER: "/transfer/patient",
  TIMELINE: "/timeline",
  ROLEMANAGEMENT: "/role",
  STAFFLISTALLPATIENT: "/list-patient",
  STAFFPROFILE: "/staff-profile",
  DOCTORPROFILE: "/doctor-profile",
  ADMISSIONDETAILS: "/admission/add",
  ADDADMISSIONDETAILS: "/admission/details/add",
  UPDATEADMISSIONDETAILS: "/admission/edit/:id",
  VIEWADMISSIONSDETAILS: "/admission/view/:id",
  LISTADMISSIONDETAILS: "/admission/list",
  TRANSFERHISTORY: "/transfer/Patient/list",
  STAFFTRANSFERHISTORY: "/transfer/Staff/transfer-Patient/list",
  LISTADMISSIONS: "/patient/list/data",
  SPECIALIST: "/specialist/list",
  DEPARTMENTLIST: "/department/list",
  STAFFDASHBOARD: "/staff/dashboard",
  DAILYREPORT: "/report/dailyLog",

  ADDROLELIST: "/role-permission/add",
  EDITROLELIST: "/role-permissions/edit/:id",  
  VIEWROLELIST: "/role-permission/view/:id",
  LISTROLELIST: "/role-permission/list",
  STAFFCHANGEPASSWORD: "/staff/change-password",
  ADDORGANIZATION: "/organization/add",
  EDITORGANIZATION: "/organization/edit/:id",
  VIEWORGANIZATION: "/organization/view/:id",
  LISTORGANIZATION: "/organization/list",
  SUPERADMINDASHBOARD: "/super-admin/dashboard",
};


export const APP_LINKS = {
  STAFFCHANGEPASSWORD: "/staff/change-password",
  STAFFMYPROFILE: "/staff/myProfile",
  STAFFLISTALLPATIENT: "/staff/list-patient",
  STAFFVIEWPATIENT: "/staff/patient/view",
  STAFFEDITPATIENT: "/staff/patient/edit",
  STAFFADDPATIENT: "/staff/patient/add",
  STAFFHISTORY: "/staff/history",
  STAFFPATIENTTRANSFER: "/staff/patientTransfer",
};

export const APP_LINKS2 = {
  DOCTORCHANGEPASSWORD: "/doctor/change-password",
  DOCTORMYPROFILE: "/doctor/myProfile",
  DOCTORDASHBOARD: "/doctor/dashboard",
  DOCTORLISTALLPATIENT: "/doctor/patient/list",
  DOCTORHISTORY: "/doctor/history",
  DOCTORPATIENTTRANSFER: "/doctor/patientTransfer",
  DOCTORLISTALLSTAFF: "/doctor/staff/list",
  LISTECURITYGUARDS: "/doctor/securityOfficer/list",
};

export const menuItems = [
 
  {
    key: "adminDashboard",
    icon: <MonitorHeartIcon />,
    label: "Dashboard",
    url: APP_LINK.DASHBOARD,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "dashboard",
    icon: <MonitorHeartIcon />,
    label: "Dashboard",
    url: APP_LINK.STAFFDASHBOARD,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "patient",
    icon: <SickIcon />,
    label: "Manage Patients",
    submenu: [
      {
        name: "Add Patient",
        icon: <AccessibilityIcon />,
        url: APP_LINK.ADDPATIENT,
         permission: "add"
      },
      {
        name: "Patients",
        icon: <AirlineSeatFlatIcon />,
        url: APP_LINK.LISTALLPATIENT,
        permission: "view"
      },
    ],
  },
  {
    key: "admissions",
    icon: <EmergencyIcon />,
    label: "Manage Admissions",
    submenu: [
      {
        name: "Add Admission",
        icon: <BloodtypeIcon />,
        url: APP_LINK.ADMISSIONDETAILS,
        permission: "add"
      },
      {
        name: "Admissions",
        icon: <HealingIcon />,
        url: APP_LINK.LISTADMISSIONDETAILS,
        permission: "view"
      },
    ],
  },
  {
    key: "doctor",
    icon: <MedicationIcon />,
    label: "Manage Doctors",
    submenu: [
      {
        name: "Add Doctor",
        icon: <MasksIcon />,
        url: APP_LINK.ADDDOCTOR,
        permission: "add"
      },
      {
        name: "Doctors",
        icon: <LocalHospitalIcon />,
        url: APP_LINK.LISTDOCTOR,
        permission: "view"
      },
    ],
  },
  {
    key: "securityOfficer",
    icon: <HealthAndSafetyIcon />,
    label: "Manage Security Officers",
    submenu: [
      {
        name: "Add Security Officer",
        icon: <AdminPanelSettingsIcon />,
        url: APP_LINK.ADDSECURITYGUARD,
        permission: "add"
      },
      {
        name: "Security Officers",
        icon: <HealthAndSafetyIcon />,
        url: APP_LINK.LISTECURITYGUARD,
        permission: "view"
      },
    ],
  },
  {
    key: "staff",
    icon: <VaccinesIcon />,
    label: "Manage Staff",
    submenu: [
      {
        name: "Add Staff",
        icon: <MedicalServicesIcon />,
        url: APP_LINK.ADDSTAFF,
        permission: "add"
      },
      {
        name: "Staffs",
        icon: <HealingIcon />,
        url: APP_LINK.LISTALLSTAFF,
        permission: "view"
      },
    ],
  },
  
  {
    key: "block",
    icon: <ApartmentIcon />,
    label: "Manage Blocks",
    url: APP_LINK.BLOCKLIST,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "floor",
    icon: <MeetingRoomIcon />,
    label: "Manage Floors",
    url: APP_LINK.FLOORLIST,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "ward",
    icon: <BedroomParentIcon />,
    label: "Manage Wards",
    url: APP_LINK.WARDLIST,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "department",
    icon: <MedicationIcon />,
    label: "Manage Departments",
    url: APP_LINK.DEPARTMENTLIST,
    permission: ["view", "add", "edit", "delete"]
  },{
    key: "staffPatientList",
    icon: <AirlineSeatFlatIcon />,
    label: "Manage Patients",
    url: APP_LINK.STAFFLISTALLPATIENT,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "specialization",
    icon: <LocalHospitalIcon />,
    label: "Manage Specializations",
    url: APP_LINK.SPECIALIST,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "patientTransfer",
    icon: <TransferWithinAStationIcon />,
    label: "Transfer Patients",
    submenu: [
      {
        name: "Transfer Patient",
        icon: <AirlineSeatFlatIcon />,
        url: APP_LINK.PATIENTTRANSFER,
         permission: "add"
      },
      {
        name: "Transfer List",
        icon: <BloodtypeIcon />,
        url: APP_LINK.STAFFTRANSFERHISTORY,
              permission: "view"
      },
    ],
  },
  {
    key: "adminTransfer",
    icon: <TransferWithinAStationIcon />,
    label: "Transfer History",
    url: APP_LINK.TRANSFERHISTORY,
    permission: "view"
  },
  {
    key: "history",
    icon: <HistoryIcon />,
    label: "Attenders History",
    url: APP_LINK.HISTORY,
    permission: "view"
  },
  // {
  //   key: "rolePermission",
  //   icon: <AppRegistrationIcon />,
  //   label: "Permissions & Access",
  //   url: APP_LINK.LISTROLELIST,
  //    submenu: [
  //     {
  //       name: "Add Roles",
  //       icon: <AdminPanelSettingsIcon />,
  //       url: APP_LINK.ADDROLELIST,
  //       permission: "add"
  //     },
  //     {
  //       name: "Roles",
  //       icon: <HealthAndSafetyIcon />,
  //       url: APP_LINK.ListROLELIST,
  //       permission: "view"
  //     },
  //   ],
  // },
  {
    key: "rolePermission",
    icon: <AppRegistrationIcon />,
    label: "Permissions & Access",
    url: APP_LINK.ROLEPERMISSION,
    permission: ["view", "add", "edit", "delete"]
  },
  {
    key: "report",
    icon: <AdminPanelSettingsIcon />,
    label: "Manage Reports",
    url: APP_LINK.DAILYREPORT,
      permission: "view"
  },
  {
    key: "profile",
    icon: <AccountCircleIcon />,
    label: "My Profile",
    url: APP_LINK.MYPROFILE,
  },
  {
    key: "staffProfile",
    icon: <AccountCircleIcon />,
    label: "My Profile",
    url: APP_LINK.STAFFPROFILE,
  },
  {
    key: "doctorProfile",
    icon: <AccountCircleIcon />,
    label: "My Profile",
    url: APP_LINK.DOCTORPROFILE,
  },
  {
    key: "changePassword",
    icon: <VpnKeyIcon />,
    label: "Change Password",
    url: APP_LINK.CHANGEPASSWORD,
  },
  {
    key: "logout",
    icon: <LogoutIcon />,
    label: "Log Out",
    url: APP_LINK.LOGOUT,
  },
];

export const SuperAdminMenu = [
  {
    key: "dashboard",
    icon: <DashboardIcon />,
    label: "Dashboard",
    url: APP_LINK.SUPERADMINDASHBOARD,
    permission: "view"
  },
  {
    key: "organization",
    icon: <ApartmentIcon />,
    label: "Manage Organizations",
    submenu: [
      {
        name: "Add Organization",
        icon: <AppRegistrationIcon />,
        url: APP_LINK.ADDORGANIZATION,
        permission: "add"
      },
      {
        name: "Organizations",
        icon: <ApartmentIcon />,
        url: APP_LINK.LISTORGANIZATION,
        permission: "view"
      },
    ],
  },
  {
    key: "profile",
    icon: <AccountCircleIcon />,
    label: "My Profile",
    url: APP_LINK.MYPROFILE,
  },
  {
    key: "changePassword",
    icon: <VpnKeyIcon />,
    label: "Change Password",
    url: APP_LINK.CHANGEPASSWORD,
  },
  {
    key: "logout",
    icon: <LogoutIcon />,
    label: "Log Out",
    url: APP_LINK.LOGOUT,
  },
];
